import React, { useState } from "react";
import { makeStyles } from "@mui/styles";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { connectivitytext } from "variables/MBM/connectivity";

import RTIotDevices from "../Connectivity/IotDevices/RTIotDevices";
import RTAVOBBox from "../Connectivity/AVOBBox/RTAVOBBox";
import RTGateways from "../Connectivity/Gateways/RTGateways";
import RTSession from "../Connectivity/Session/RTSession";
import RTEquipments from "./Equipments/RTEquipments";
import Dashboard from "./Dashboard/Dashboard";
import RTVirtualSensors from "./VirtualSensors/RTVirtualSensors";
import RTEntities from "./Entities/RTEntities";
import RTLorawanThread from "../Connectivity/LorawanThreads/RTLorawanThread";
// import Monitoring from "./Monitoring/Monitoring";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "0 0 5px 5px",
    boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
    textTransform: "none",
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  tabPanel: {
    padding: "0",
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>{children}</>

      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}


export default function SupervisionVT(props) {
  const classes = useStyles();
  const currentusertype = localStorage.getItem('userType');
  const [value, setValue] = useState("1");

  const handleTabChange = (event, newValue) => {
    console.log(event, newValue);
    setValue(newValue);
  };


  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={2} lg={1}>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleTabChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
            TabIndicatorProps={{ style: { background: "#91C73C" } }}
          >
            <Tab className={classes.tab} label="Dashboard" {...a11yProps(1)} value="1" />
            <Tab className={classes.tab} label="Equipements" {...a11yProps(2)} value="2" />
            <Tab className={classes.tab} label={connectivitytext.iot} {...a11yProps(3)} value="3" />
            <Tab className={classes.tab} label={connectivitytext.gateways} {...a11yProps(4)} value="4" />
            <Tab className={classes.tab} label={connectivitytext.avobbox} {...a11yProps(5)} value="5" />
            {
              currentusertype == 1 &&
              <Tab className={classes.tab} label={connectivitytext.session} {...a11yProps(6)} value="6" />
            }
            {
              (currentusertype == 1 || currentusertype == 3) &&
              <Tab className={classes.tab} label={connectivitytext.virtualsensors} {...a11yProps(7)} value="7" />
            }
            {
              currentusertype == 1 &&
              <Tab className={classes.tab} label={connectivitytext.entities} {...a11yProps(8)} value="8" />
            }
            {
              currentusertype == 1 &&
              <Tab className={classes.tab} label={connectivitytext.lorawanthreads} {...a11yProps(9)} value="9" />
            }
            {/* <Tab className={classes.tab} label="Surveillance" {...a11yProps(2)} /> */}
          </Tabs>
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={11}>
          <TabPanel value={value} index={"1"} className={classes.tabPanel} >
            <Dashboard />
          </TabPanel>
          <TabPanel value={value} index={"2"} className={classes.tabPanel} >
            <RTEquipments />
          </TabPanel>
          <TabPanel value={value} index={"3"} className={classes.tabPanel} >
            <RTIotDevices />
          </TabPanel>
          <TabPanel value={value} index={"4"} className={classes.tabPanel} >
            <RTGateways />
          </TabPanel>
          <TabPanel value={value} index={"5"} className={classes.tabPanel} >
            <RTAVOBBox />
          </TabPanel>
          {
            (currentusertype == 1 || currentusertype == 3) &&
            <TabPanel value={value} index={"6"} className={classes.tabPanel} >
              <RTSession />
            </TabPanel>
          }
          {
            (currentusertype == 1 || currentusertype == 3) &&
            <TabPanel value={value} index={"7"} className={classes.tabPanel} >
              <RTVirtualSensors />
            </TabPanel>
          }
          {
            currentusertype == 1 &&
            <TabPanel value={value} index={"8"} className={classes.tabPanel} >
              <RTEntities />
            </TabPanel>
          }
          {
            currentusertype == 1 &&
            <TabPanel value={value} index={"9"} className={classes.tabPanel} >
              <RTLorawanThread />
            </TabPanel>
          }
          {/* <TabPanel value={value} index={2} className={classes.tabPanel} >
            <Monitoring />
          </TabPanel> */}
        </GridItem>
      </GridContainer>
    </div>

  );
}
